import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "b-table-header",
  wrap: ""
}
const _hoisted_2 = { class: "vstack gap-2" }
const _hoisted_3 = { class: "hstack" }
const _hoisted_4 = { class: "hstack gap-2" }
const _hoisted_5 = {
  key: 0,
  class: "hstack gap-2 ms-auto"
}

import { ref, watch, onMounted } from 'vue';
    import { BTableOptions } from "./BTable.types";
    import PaginationDefault from "@/components/Pagination/PaginationDefault.vue";
    import PaginationNoLastOrTotal from "@/components/Pagination/PaginationNoLastOrTotal.vue";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BTableHeader',
  props: {
    value: {},
    headerSlotClass: { default: '' },
    currentItemCount: {},
    filters: { default: [] }
  },
  emits: ['optionChange'],
  setup(__props: any, { emit: __emit }) {

    const emits = __emit;

    const props = __props; 

    var options = ref(props.value as BTableOptions);

    var isNextDisabled = ref(false);

    function handleOptionChange(newOptions){
        options.value = newOptions;
        emits("optionChange", options.value);
    }

    function setNextButtonState(){
        if (props.currentItemCount && options.value) {
            isNextDisabled.value = props.currentItemCount <= options.value.itemsPerPage;
        }
    }

    watch(
    () => props.currentItemCount,
    (val) => {
        setNextButtonState();
    });

    onMounted(() => {
        setNextButtonState();      
    });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.headerSlotClass)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "headerTopBar")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default"),
          (_ctx.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "pagingStart"),
                (_ctx.value.pagingMode == 'withTotal')
                  ? (_openBlock(), _createBlock(PaginationDefault, {
                      key: 0,
                      "header-slot-class": _ctx.headerSlotClass,
                      value: _ctx.value,
                      onOptionChange: handleOptionChange
                    }, null, 8, ["header-slot-class", "value"]))
                  : (_openBlock(), _createBlock(PaginationNoLastOrTotal, {
                      key: 1,
                      "header-slot-class": _ctx.headerSlotClass,
                      value: _ctx.value,
                      "is-previous-disabled": _ctx.value.page == 1,
                      "is-next-disabled": _unref(isNextDisabled),
                      filters: props.filters,
                      onOptionChange: handleOptionChange,
                      "current-item-count": props.currentItemCount
                    }, null, 8, ["header-slot-class", "value", "is-previous-disabled", "is-next-disabled", "filters", "current-item-count"]))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2)
  ]))
}
}

})